import React from "react";
import SectionTitle from "../SectionTitle/SectionTitle";
import licenseImage from "../../images/image.png";

const BlogSection = () => {
  return (
    <section className="wpo-blog-section section-padding">
      <div className="container">
        <SectionTitle subtitle={"Сертификат"} title={"Лицензия"} />
        <div className="wpo-blog-items">
          <div className="row justify-content-around">
            <div className="col col-lg-4 col-md-6 col-12">
              <div className="wpo-blog-item">
                <div className="wpo-blog-img">
                  <img src={licenseImage} alt="Лицензия" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
